import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5985128"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Guests", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "search-form" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Search Guests", -1))
const _hoisted_6 = ["onKeyup"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { style: {"min-width":"900px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Email")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Phone")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Actions")
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" View ")
const _hoisted_11 = {
  key: 0,
  class: "pagination"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 3,
  class: "text-center"
}

import { computed, onMounted, ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";

interface NbGuestListRow {
  guest_id?: number | string;
  id?: number | string;
  guest_name?: string | null;
  name?: string | null;
  guest_firstname?: string | null;
  guest_lastname?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  guest_email?: string | null;
  guest_phone?: string | null;
  guest_mobile?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  email?: string | null;
  phone?: string | null;
  mobile?: string | null;
  contact_details?: NbGuestContactDetail[];
}

interface NbGuestContactDetail {
  type?: string | null;
  content?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    facilityId: null,
    facilityName: null
  },
  setup(__props: any) {

const props = __props as {
  facilityId: string;
  facilityName?: string;
}



const searchQuery = ref("");
const status = ref("idle");
const guests = ref<NbGuestListRow[]>([]);
const errorMessage = ref("");
const dataOffset = ref(0);
const dataLimit = ref(100);
const dataTotal = ref(0);
const hasDisplayableGuestData = (guest: NbGuestListRow) =>
  [guestId(guest), guestName(guest), guestEmail(guest), guestPhone(guest)].some(
    (value) => (value ?? "").toString().trim().length > 0
  );

const visibleGuests = computed(() =>
  guests.value.filter((guest) => guest && hasDisplayableGuestData(guest))
);

onMounted(() => {
  loadGuests();
});

async function loadGuests() {
  errorMessage.value = "";
  status.value = "loading";
  guests.value = [];

  const params: Record<string, string> = {
    facilityId: props.facilityId,
    data_offset: String(dataOffset.value),
    data_limit: String(dataLimit.value),
  };
  if (searchQuery.value.trim()) {
    params.search_query = searchQuery.value.trim();
  }

  try {
    const qs = new URLSearchParams(params).toString();
    const response = await api({
      url: `nb/guests/?${qs}`,
      method: "GET",
    });

    if (response.ok) {
      const responseGuests = response.body.data;
      guests.value = Array.isArray(responseGuests)
        ? (responseGuests as NbGuestListRow[])
        : [];
      dataTotal.value = response.body.data_total || visibleGuests.value.length;
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to load guests.";
    }
  } catch {
    errorMessage.value = "An error occurred while loading guests.";
  }

  status.value = "loaded";
}

function prevPage() {
  dataOffset.value = Math.max(0, dataOffset.value - dataLimit.value);
  loadGuests();
}

function nextPage() {
  dataOffset.value += dataLimit.value;
  loadGuests();
}

function guestId(guest: NbGuestListRow) {
  return guest.guest_id || guest.id || "";
}

function guestName(guest: NbGuestListRow) {
  const first = guest.guest_firstname || guest.firstname || "";
  const last = guest.guest_lastname || guest.lastname || "";
  return (
    guest.guest_name ||
    guest.name ||
    [first, last].filter(Boolean).join(" ") ||
    `Guest ${guestId(guest)}`
  );
}

function contactDetail(guest: NbGuestListRow, types: string[]) {
  const details = Array.isArray(guest.contact_details)
    ? guest.contact_details
    : [];
  const match = details.find((detail) =>
    types.includes((detail.type || "").toString().toLowerCase())
  );
  return match?.content || "";
}

function guestEmail(guest: NbGuestListRow) {
  return (
    guest.guest_email ||
    guest.contact_email ||
    guest.email ||
    contactDetail(guest, ["email"])
  );
}

function guestPhone(guest: NbGuestListRow) {
  return (
    guest.guest_phone ||
    guest.guest_mobile ||
    guest.contact_phone ||
    guest.phone ||
    guest.mobile ||
    contactDetail(guest, ["phone", "mobile", "cell", "telephone"])
  );
}

function formatPhoneNumber(phoneNumber?: string | null) {
  if (!phoneNumber) {
    return "";
  }

  const trimmedPhoneNumber = phoneNumber.trim();
  if (
    trimmedPhoneNumber.startsWith("+") &&
    !trimmedPhoneNumber.startsWith("+1")
  ) {
    return phoneNumber;
  }

  let extension = "";
  let phoneText = phoneNumber;
  const extensionMatch = phoneNumber.match(
    /(?:ext\.?|extension|x)\s*(\d+)\s*$/i
  );
  if (extensionMatch?.index !== undefined) {
    extension = extensionMatch[1];
    phoneText = phoneNumber.substring(0, extensionMatch.index);
  }

  let digits = phoneText.replace(/\D/g, "");
  if (digits.length >= 11 && digits.startsWith("1")) {
    digits = digits.substring(1);
  }
  if (digits.length >= 10) {
    if (!extension && digits.length > 10) {
      extension = digits.substring(10);
    }
    const formatted = `(${digits.substring(0, 3)}) ${digits.substring(
      3,
      6
    )}-${digits.substring(6, 10)}`;
    return extension ? `${formatted} x${extension}` : formatted;
  }

  return phoneNumber;
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            style: {"max-width":"400px"},
            placeholder: "Name, email, or phone...",
            onKeyup: _withKeys(loadGuests, ["enter"])
          }, null, 40, _hoisted_6), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-blue",
          onClick: loadGuests
        }, "Search")
      ]),
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            dismissible: "",
            onDismissed: _cache[1] || (_cache[1] = ($event: any) => (errorMessage.value = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (status.value === 'loaded' && _unref(visibleGuests).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleGuests), (guest) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: guestId(guest)
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: {
                name: 'nb_guest_detail',
                params: {
                  guestId: guestId(guest),
                  facilityId: __props.facilityId,
                  facilityName: __props.facilityName,
                },
              }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(guestName(guest)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(guestEmail(guest) || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(formatPhoneNumber(guestPhone(guest)) || "-"), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      class: "btn btn-sm",
                      to: {
                name: 'nb_guest_detail',
                params: {
                  guestId: guestId(guest),
                  facilityId: __props.facilityId,
                  facilityName: __props.facilityName,
                },
              }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ]),
            (dataTotal.value > _unref(visibleGuests).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "btn",
                    disabled: dataOffset.value === 0,
                    onClick: prevPage
                  }, " Previous ", 8, _hoisted_12),
                  _createElementVNode("span", null, " Showing " + _toDisplayString(dataOffset.value + 1) + "-" + _toDisplayString(dataOffset.value + _unref(visibleGuests).length) + " of " + _toDisplayString(dataTotal.value), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    disabled: dataOffset.value + _unref(visibleGuests).length >= dataTotal.value,
                    onClick: nextPage
                  }, " Next ", 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (status.value === 'loaded')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No guests found. "))
          : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})